<div class="box">
  <div id="googleLoginBtn"></div>
</div>
